"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketTaggingInput_1 = require("./DeleteBucketTaggingInput");
var DeleteBucketTaggingOutput_1 = require("./DeleteBucketTaggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketTagging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketTagging",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?tagging"
    },
    input: {
        shape: DeleteBucketTaggingInput_1.DeleteBucketTaggingInput
    },
    output: {
        shape: DeleteBucketTaggingOutput_1.DeleteBucketTaggingOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketTagging.js.map